export interface FeatureFlags {
  exampleFeatureFlag: boolean;
  manageCityBaseRates03Mar2022: boolean;
}

export enum FeatureFlagTrackEvents {
  EXAMPLE_EVENT_NAME = 'Example Event Name',
}
